import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {  Observable } from "rxjs";
import { costsRequest, PrePurchaseResponseCart } from "./interfaces/pre-purchase.interface";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PrePurchaseCostsService {
  private apiUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,

  ) { }

  sendCosts(data: costsRequest): Observable<PrePurchaseResponseCart> {
    return this.http.post<PrePurchaseResponseCart>(`${this.apiUrl}/pre_purchase/costos`, data)
  }


}
